import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage, useIntl } from 'react-intl';

import { useGlobaResize } from '../../containers/App/hooks/useWindowEvent';

import { getStorageHeight, updateLocalStorage } from './utils';
import {
  Icon,
  Wrapper,
  WrapperText,
  TextCol,
  Arrow,
  Row,
  InfoText,
} from './styles';

const UpCustomerSettingsInfoComponent = ({ content, storageKey }) => {
  const [height, setHeight] = useState(getStorageHeight(storageKey));
  const contentEl = useRef(null);
  const { locale } = useIntl();

  useEffect(() => {
    if (height !== '0px' && contentEl.current && contentEl.current !== height)
      setHeight(`${contentEl.current.offsetHeight}px`);
  }, [height, locale, content]);

  const updateDimensions = () => {
    if (height !== '0px' && contentEl.current && contentEl.current !== height)
      setHeight(`${contentEl.current.offsetHeight}px`);
  };

  useGlobaResize(updateDimensions);

  const toggleInfo = (flag = 'toggle') => {
    let currentVisibleState = true;

    if (contentEl.current) {
      switch (flag) {
        case 'close':
          setHeight('0px');
          break;
        default:
          currentVisibleState = height !== '0px';
          setHeight(
            currentVisibleState ? '0px' : `${contentEl.current.offsetHeight}px`,
          );
          break;
      }
    }

    if (storageKey) updateLocalStorage(storageKey, !currentVisibleState);
  };

  return (
    <Wrapper>
      {Object.values(content).some((item) => item !== undefined) && (
        <>
          <Icon>
            <FontAwesomeIcon
              icon="question-circle"
              onClick={() => toggleInfo()}
            />
          </Icon>
          <WrapperText height={height}>
            <InfoText ref={contentEl}>
              <Row>
                {Object.entries(content).map(([key, value]) => {
                  let msg = key.charAt(0).toUpperCase() + key.slice(1);
                  if (key === 'recommendation') msg = `uptain-${msg}`;

                  return (
                    value && (
                      <TextCol key={key}>
                        <FormattedMessage
                          id={`components.UpCustomerSettingsInfoComponent.${key}`}
                          defaultMessage={msg}
                          tagName="span"
                        />
                        {value}
                      </TextCol>
                    )
                  );
                })}
              </Row>
              <Arrow onClick={() => toggleInfo('close')} />
            </InfoText>
          </WrapperText>
        </>
      )}
    </Wrapper>
  );
};

UpCustomerSettingsInfoComponent.propTypes = {
  content: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  ),
  storageKey: PropTypes.string,
};

export default UpCustomerSettingsInfoComponent;
